import { DateTime } from "luxon";
import moment from "moment";
const WEEK_DAYS_BY_INDEX = {
    0: { name: "Sunday", short: "SU" },
    1: { name: "Monday", short: "MO" },
    2: { name: "Tuesday", short: "TU" },
    3: { name: "Wednesday", short: "WE" },
    4: { name: "Thursday", short: "TH" },
    5: { name: "Friday", short: "FR" },
    6: { name: "Saturday", short: "SA" },
};
export const DAYS_OF_WEEK = Object.values(WEEK_DAYS_BY_INDEX);
export const momentToDayOfWeek = (m) => {
    return WEEK_DAYS_BY_INDEX[m.weekday()].short;
};
// Ant Design component take dates in "moment" form, but if we want to properly
// propagate date ranges across time zones we need to use "luxon" or a similar package.
// Hopefully, Ant will abandon moment soon and we can phase it out entirely.
export const momentToISO = (x) => {
    return x.format();
};
export const firestoreToLuxon = (x) => {
    return DateTime.fromJSDate(x.toDate());
};
//TODO: Move away from firestore towards raw millisecond counts as they don't require
//separate serialization for api calls.
export const firestoreToMoment = (x) => {
    return moment(x.toDate().toISOString());
};
export const firestoreToISO = (x) => {
    return x.toDate().toISOString();
};
/**
 * Print a timestamp to the UI.
 * TODO: This can surely be improved
 */
export const printDate = (x) => {
    if (!x)
        return;
    return x.toDate().toDateString();
};
export const stringifyMomentDefault = (x) => {
    return x.format("dddd, MMMM Do YYYY, h:mm a"); // Tuesday, February 8th 2021, 12:20:30 am
};
export const stringifyFirestoreDefault = (x) => {
    return stringifyMomentDefault(firestoreToMoment(x));
};
/**
 * The date format for order e-mails
 */
export const orderEmailDate = (x) => {
    return moment(x).format("dddd, MMMM Do YYYY");
};
//# sourceMappingURL=dates.js.map